import { RootObject } from '@/model/rootObject'
import { https } from '@/utils/https'
import { ContentType, Method } from 'axios-mapper'
import { setupService, testApi } from '@/config'

/**
 * 
 * @param data 获取用户信息
 * @returns 
 */
export const getUsersInfo = () => {
  return https().request(`/mngserver/userInfo`, Method.GET, undefined, ContentType.json)
}

/**
 * 
 * @param data 登录
 * @returns 
 */
export const login = (data: any) => {
  return https().request(`/server/login`, Method.POST, data, ContentType.json)
}

/**
 * 
 * @returns 获取当前版本更新的时间
 */
export const getPadVersionTimer = () => {
  return https().request(`/pad_mtime`, Method.GET, undefined, ContentType.json)
}
